import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CustomLoader from "../../components/CustomeLoader";
import socialicon3 from "../../ulits/images/social-icon3.svg";
import shareicon from "../../ulits/images/share-icon.svg";
import usericon from "../../ulits/images/user_icon.svg";
import warrantyicon from "../../ulits/images/warranty_icon.svg";
import serviceicon from "../../ulits/images/service_icon.svg";
import { Modal } from "react-bootstrap";
import driveicon from "../../ulits/images/drive_icon.svg";
import { configs } from "../../config";
import Accordion from "react-bootstrap/Accordion";
import monthicon from "../../ulits/images/month_icon.svg";
import searchicon from "../../ulits/images/search_icon.svg";
import checkedicon from "../../ulits/images/checked_icon.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation, Thumbs } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { homeAction } from "../../_actions/home.action";
import parse from "html-react-parser";
import { status } from "../../_constants/commonLhd";
import { Helmet } from "react-helmet";
import Printicon from "../../ulits/images/Print_icon.svg";
import caricon from "../../ulits/images/car_icon.svg";
import partExchnage from "../../ulits/images/partExchange.svg";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import makeicon from "../../ulits/images/make_icon.svg";
import gearIcon from "../../ulits/images/engine_icon.png";

function CarDetails() {
  const [loader, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const location = useLocation();
  const [cars, setCars] = useState(location.state || null);
  const [active, setActive] = useState("button1");
  const navigate = useNavigate();
  const [isValidate2, setIsValidate2] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const { slug } = useParams();
  const faqData = useSelector((state) => state.faq);
  const faqList =
    faqData?.faq_data?.filter((item) => item.status === true) || [];

  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const mainSwiperRef = useRef(null);
  const [activeButtonIndex, setActiveButtonIndex] = useState(0);
  const [printTrigger, setPrintTrigger] = useState(false);
  const [error2, setError2] = useState({});
  const [modalType, setModalType] = useState("");

  const handlePrint = async () => {
    const element = document.querySelector(".print-area");

    if (!element) {
      console.error("No element with class .print-area found");
      return;
    }

    try {
      const isMobile = window.innerWidth <= 480;

      element.classList.add(
        "print-ready",
        isMobile ? "mobile-layout" : "desktop-layout"
      );

      await new Promise((resolve) => setTimeout(resolve, 100));

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        width: isMobile ? 375 : undefined,
        windowWidth: isMobile ? 375 : undefined,
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = isMobile
        ? new jsPDF("p", "mm", [80, 320])
        : new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      const fileName =
        (cars?.details ? cars.details.replace(/\s+/g, "_") : "car-details") +
        ".pdf";

      pdf.save(fileName);
    } catch (error) {
      console.error("PDF generation error:", error);
    } finally {
      element.classList.remove("mobile-layout");
      element.classList.remove("desktop-layout");
    }
  };

  useEffect(() => {
    if (printTrigger) {
      window.print();
      setPrintTrigger(false);
    }
  }, [printTrigger]);

  // const [credentials, setCredentials] = useState({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   bestTime: "",
  // });

  const [credentials2, setCredentials2] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const dispatch = useDispatch();

  const homeData = useSelector((state) => state.home);

  useEffect(() => {
    if (cars) {
      dispatch(homeAction.getCarDetail({ slug }));
    }
    // else {
    //   setLoading(false);
    // }
  }, [dispatch, slug]);

  useEffect(() => {
    if (homeData && homeData.car_details_status === status.SUCCESS) {
      setCars(homeData.car_details_data);
      // setLoading(false);
    }
  }, [homeData]);

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && value.length > 12) {
      return;
    }
    setCredentials2((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, []);

  const handleModal2Close = () => {
    setModal2(false);
  };
  const handleModal2Open = () => {
    setModal2(true);
  };

  const validateCredentials2 = (data) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const PhoneRegex = /^\d{10,12}$/;
    const errors = {
      name: { message: "" },
      email: { message: "" },
      phone: { message: "" },
      message: { message: "" },
      isValid: true,
    };

    if (!data.name || data.name.length <= 2) {
      errors.name.message = "Name must be at least 3 characters";
      errors.isValid = false;
    }

    if (!data.email || !emailRegex.test(data.email)) {
      errors.email.message = "Enter valid email";
      errors.isValid = false;
    }

    if (!data.phone || !PhoneRegex.test(data.phone)) {
      errors.phone.message = "Enter a valid phone number";
      errors.isValid = false;
    }

    if (!data.message || data.message.trim() === "") {
      errors.message.message = "Please enter your message";
      errors.isValid = false;
    }

    return errors;
  };

  const handleSubmit2 = (e) => {
    e.preventDefault();

    const errors = validateCredentials2(credentials2);
    setError2(errors);

    if (errors.isValid) {
      if (modalType === "vehicle") {
        dispatch(homeAction.carInquiry(credentials2));
      } else if (modalType === "partExchange") {
        dispatch(homeAction.partExchangeInquiry(credentials2));
      }

      handleModal2Close();
      setCredentials2({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
      setError2({});
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          image: window.location.href,
          title: "Check this out!",
          text: "Visit this amazing website!",
          url: window.location.href,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert("Sharing is not supported on this device.");
    }
  };

  // const [activeButtonIndex, setActiveButtonIndex] = React.useState(null);

  return (
    <>
      <Helmet>
        <meta name="description" content={cars && cars.metaDescription} />
        <meta name="keywords" content={cars && cars.metaKeywords} />
      </Helmet>
      {loader ? (
        <CustomLoader />
      ) : (
        // <div ref={printRef} className="main-wrapper print-area">
        <div className="main-wrapper">
          <div className="car-listing-section car-details print-area">
            <div className="container">
              <div className="modern-filter-listing">
                <div className="car-listing-right">
                  <div className="car-listing-right-top-left-text">
                    {/* <div className="car-top-section">
                      <ul>
                        <li>
                          <Link to="/">Home</Link>
                        </li>
                        /
                        <li>
                          <Link to="/car-listing">Car Listing</Link>
                        </li>
                        /
                        <li>
                          <Link to="#">{cars && cars.details}</Link>
                        </li>
                      </ul>
                    </div> */}
                    <h1>{cars && cars.details}</h1>
                  </div>
                  <div className="car-list-btn">
                    <button
                      className={`primary-btn sm ${activeButtonIndex === 0 ? "active" : ""
                        }`}
                      onClick={() => {
                        setActiveButtonIndex(0);
                        handleModal2Open();
                        setModalType("vehicle");
                      }}
                    >
                      <div className="car_icon" />
                      <span>VEHICLE ENQUIRY</span>
                    </button>
                    <button
                      className={`primary-btn sm ${activeButtonIndex === 1 ? "active" : ""
                        }`}
                      onClick={() => {
                        setActiveButtonIndex(1);
                        setModalType("partExchange");
                        handleModal2Open();
                      }}
                    >
                      <img src={partExchnage} alt="" />
                      <span>PART EXCHANGE</span>
                    </button>
                    {/* <button
                      className={`primary-btn sm ${activeButtonIndex === 1 ? 'active' : ''}`}
                      onClick={() => {
                        setActiveButtonIndex(1);
                        handleModal2Open();
                      }}
                    >
                      <img src={socialicon3} alt="" />
                      <span>SCHEDULT TEST DRIVE</span>
                    </button> */}
                    <button
                      className={`primary-btn sm ${activeButtonIndex === 2 ? "active" : ""
                        }`}
                      onClick={() => {
                        setActiveButtonIndex(2);
                        handleShare();
                      }}
                    >
                      <img src={shareicon} alt="" />
                      <Link style={{ textDecoration: "none" }}>
                        <span> SHARE THIS</span>
                      </Link>
                      {/* SHARE THIS */}
                    </button>
                    {/* <div className="print"> */}
                    <div className="print">
                      <button
                        className={`primary-btn sm ${activeButtonIndex === 3 ? "active" : ""
                          }`}
                        onClick={() => {
                          setActiveButtonIndex(3);
                          handlePrint();
                        }}
                      >
                        <img src={Printicon} alt="" />
                        <span>Print</span>
                      </button>
                    </div>
                  </div>
                  <div className="car-list-img"></div>

                  <div>
                    <div className="swiper-container swiper-container2">
                      <div className="swiper-button-prev custom-prev"></div>
                      <div className="swiper-button-next custom-next"></div>
                      <Swiper
                        onSwiper={(swiper) => (mainSwiperRef.current = swiper)}
                        // navigation={true}
                        thumbs={{
                          swiper:
                            thumbsSwiper && !thumbsSwiper.destroyed
                              ? thumbsSwiper
                              : null,
                        }}
                        navigation={{
                          nextEl: ".custom-next",
                          prevEl: ".custom-prev",
                        }}
                        modules={[Navigation, Thumbs]}
                        spaceBetween={0}
                        className="image-container first-slider"
                      >
                        {cars?.image?.map((img, index) => (
                          <SwiperSlide key={index}>
                            <img
                              src={`${configs.localApiUrl}${img}`}
                              alt={`slide-${index}`}
                              style={{
                                width: "100%",
                                // height: "400px",
                                objectFit: "cover",
                              }}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                    <div className="swiper-container">
                      <div className="swiper-button-prev custom-prev"></div>
                      <div className="swiper-button-next custom-next"></div>
                      <Swiper
                        onSwiper={(swiper) => {
                          setThumbsSwiper(swiper);
                          swiper.on("slideChange", () => {
                            if (
                              mainSwiperRef.current &&
                              !mainSwiperRef.current.destroyed
                            ) {
                              mainSwiperRef.current.slideTo(swiper.activeIndex);
                            }
                          });
                        }}
                        watchSlidesProgress
                        slidesPerView={4}
                        spaceBetween={10}
                        navigation={{
                          nextEl: ".custom-next",
                          prevEl: ".custom-prev",
                        }}
                        modules={[Navigation, Thumbs]}
                        className="image-container"
                        style={{ marginTop: "20px" }}
                        breakpoints={{
                          320: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                          },
                          480: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                          },
                          640: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                          },
                          768: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                          },
                          1024: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                          },
                        }}
                      >
                        {cars?.image?.map((img, index) => (
                          <SwiperSlide key={index}>
                            <img
                              src={`${configs.localApiUrl}${img}`}
                              alt={`thumb-${index}`}
                              style={{
                                width: "100%",
                                // height: "100px",
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                            />
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  </div>

                  <div className="car-listing-right-bottom">
                    <div className="stm-accordion-single-unit right-hand-drive">
                      <Accordion >
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>DESCRIPTION</Accordion.Header>
                          <Accordion.Body>
                            {/* {parse(cars && cars.description)} */}
                            {cars && cars.description ? (
                              parse(cars.description)
                            ) : (
                              <p>No description available</p>
                            )}
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            ADDITIONAL INFORMATION
                          </Accordion.Header>
                          <Accordion.Body>
                            <div className="information">
                              <div className="addi-information">
                                  {cars && cars.carOwner ? (
                                    <div className="box">
                                      <div className="information-text">
                                        <>
                                          <img src={usericon} alt="" />
                                          {cars && cars.carOwner ? `${cars.carOwner} ${parseInt(cars.carOwner) === 1
                                            ? "Owner"
                                            : "Owners"}` : ""}
                                        </>
                                      </div>
                                    </div>
                                  ) : null}
                                  {cars && cars.carWarranty ? (
                                    <div className="box">
                                      <div className="information-text">
                                        <>
                                          <img src={warrantyicon} alt="" />
                                          {cars && cars.carWarranty ? `${cars.carWarranty}` : ""}
                                        </>
                                      </div>
                                    </div>
                                  ) : null}
                                {cars && cars.serviceHistory ? (
                                  <div className="box">
                                    <div className="information-text">
                                      <>
                                        <img src={serviceicon} alt="" />
                                        Full Service History
                                      </>
                                    </div>
                                  </div>
                                ) : null}
                                  {cars && cars.carMot ? (
                                    <div className="box">
                                      <div className="information-text">
                                        <>
                                          <img src={monthicon} alt="" />
                                          {cars && cars.carMot ? `${cars.carMot} ` : ""}
                                        </>
                                      </div>
                                    </div>
                                  ) : null}
                                {cars && cars.preInspection ? (
                                  <div className="box">
                                    <div className="information-text">
                                      <>
                                        <img src={searchicon} alt="" />
                                        Pre Inspection
                                      </>
                                    </div>
                                  </div>
                                ) : null}
                                {cars && cars.hpiChecked ? (
                                  <div className="box">
                                    <div className="information-text">
                                      <>
                                        <img
                                          src={checkedicon}
                                          alt="Checked Icon"
                                        />
                                        HPI Checked
                                      </>
                                    </div>
                                  </div>
                                ) : null}
                                  {cars && cars.company ? (
                                    <div className="box">
                                      <div className="information-text">
                                        <>
                                          <img src={makeicon} alt="" />
                                          {cars && cars.company ? `${cars.company}` : ""}
                                        </>
                                      </div>
                                    </div>
                                  ) : null}
                                   {cars && cars.model ? (
                                    <div className="box">
                                      <div className="information-text">
                                        <>
                                          <img src={gearIcon} alt="" />
                                          {cars && cars.model ? `${cars.model}` : ""}
                                        </>
                                      </div>
                                    </div>
                                  ) : null}
                              </div>
                              <div className="addi-information"></div>
                              <div className="addi-information"></div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item
                          eventKey="2"
                          className="car-listing-left-accordion"
                        >
                          <Accordion.Header>SPECIFICATION</Accordion.Header>
                          <Accordion.Body>
                            <div className="car-listing-left">
                              <h5>
                                £
                                {Number(cars && cars.price).toLocaleString(
                                  "en-IN"
                                )}
                              </h5>
                              <div className="row">
                                <div className="details-box">
                                  <div className="inner-title-text">
                                    <h3>MAKE</h3>
                                    <p>
                                      {cars &&
                                        cars.company &&
                                        cars.company.toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>MANUFACTURING YEAR</h3>
                                    <p>
                                      {cars &&
                                        cars.menuFacturingYear &&
                                        cars.menuFacturingYear}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>BODY</h3>
                                    <p>
                                      {cars &&
                                        cars.body &&
                                        cars.body.toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>GEARBOX</h3>
                                    <p>
                                      {cars &&
                                        cars.transmission.toUpperCase() ===
                                        "AUTOMATIC"
                                        ? "AUTO"
                                        : cars.transmission.toUpperCase() ===
                                          "SEMI AUTOMATIC"
                                          ? "SEMI AUTO"
                                          : cars.transmission}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>MODEL</h3>
                                    <p>
                                      {cars &&
                                        cars.model &&
                                        cars.model.toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>EXTERIOR COLOUR</h3>
                                    <p>
                                      {cars &&
                                        cars.exteriorColor &&
                                        cars.exteriorColor.toUpperCase()}
                                    </p>
                                  </div>

                                  <div className="inner-title-text">
                                    <h3>SEATS</h3>
                                    <p>
                                      {cars &&
                                        cars.seats &&
                                        cars.seats.toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>INTERIOR COLOUR</h3>
                                    <p>
                                      {cars &&
                                        cars.interiorColor &&
                                        cars.interiorColor.toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>DOORS</h3>
                                    <p>
                                      {cars &&
                                        cars.doors &&
                                        cars.doors.toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>MILEAGE</h3>
                                    <p>
                                      {" "}
                                      {Number(
                                        cars && cars.mileage
                                      ).toLocaleString("en-IN")}{" "}
                                      MILES
                                    </p>
                                  </div>
                                  <div className="inner-title-text">
                                    <h3>FUEL TYPE</h3>
                                    <p>
                                      {cars &&
                                        cars.fuelType &&
                                        cars.fuelType.toUpperCase()}
                                    </p>
                                  </div>



                                  <div className="inner-title-text">
                                    <h3>COUNTRY</h3>
                                    <p>{cars && cars.country}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>

                      <div className="group-btn d-none d-md-block ">
                        {/* <button
                          className={active === "button1" ? "active" : ""}
                          onClick={handleModal2Open}
                        >
                          <img src={caricon} alt="" />
                          VEHICLE ENQUIRY
                        </button> */}
                        {/* TO DO */}
                        {/* <button
                      className={active === "button2" ? "active" : ""}
                      onClick={() => setActive("button2")}
                    >
                      PART EXCHANGE
                    </button> */}
                      </div>
                    </div>
                    {/* <div className="car-listing-left">
                      <h5>£{cars && cars.price}</h5>
                      <div className="details-box">
                        <div className="inner-title-text">
                          <h3>BODY</h3>
                          <p>
                            {cars && cars.model && cars.model.toUpperCase()}
                          </p>
                        </div>
                        <div className="inner-title-text">
                          <h3>MILEAGE</h3>
                          <p>{cars && cars.mileage} MILES</p>
                        </div>
                        <div className="inner-title-text">
                          <h3>FUEL TYPE</h3>
                          <p>
                            {cars && cars.model && cars.fuelType.toUpperCase()}
                          </p>
                        </div>
                        <div className="inner-title-text">
                          <h3>ENGINE</h3>
                          <p>{cars && cars.engine}</p>
                        </div>
                        <div className="inner-title-text">
                          <h3>TRANSMISSION</h3>
                          <p>
                            {cars &&
                              cars.model &&
                              cars.transmission.toUpperCase()}
                          </p>
                        </div>
                        <div className="inner-title-text">
                          <h3>EXTERIOR COLOUR</h3>
                          <p>
                            {cars &&
                              cars.model &&
                              cars.exteriorColor.toUpperCase()}
                          </p>
                        </div>
                        <div className="inner-title-text">
                          <h3>INTERIOR COLOUR</h3>
                          <p>
                            {cars &&
                              cars.model &&
                              cars.interiorColor.toUpperCase()}
                          </p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="car-list-btn second">
                    <button
                      className={`primary-btn sm ${activeButtonIndex === 0 ? "active" : ""
                        }`}
                      onClick={() => {
                        setActiveButtonIndex(0);
                        handleModal2Open();
                        setModalType("vehicle");
                      }}
                    >
                      <div className="car_icon" />
                      <span>VEHICLE ENQUIRY</span>
                    </button>
                    <button
                      className={`primary-btn sm ${activeButtonIndex === 1 ? "active" : ""
                        }`}
                      onClick={() => {
                        setActiveButtonIndex(1);
                        handleModal2Open();
                        setModalType("partExchange");
                      }}
                    >
                      <img src={partExchnage} alt="" />
                      <span>PART EXCHANGE</span>
                    </button>
                    {/* <button
                      className={`primary-btn sm ${activeButtonIndex === 1 ? 'active' : ''}`}
                      onClick={() => {
                        setActiveButtonIndex(1);
                        handleModal2Open();
                      }}
                    >
                      <img src={socialicon3} alt="" />
                      <span>SCHEDULT TEST DRIVE</span>
                    </button> */}
                    <button
                      className={`primary-btn sm ${activeButtonIndex === 2 ? "active" : ""
                        }`}
                      onClick={() => {
                        setActiveButtonIndex(2);
                        handleShare();
                      }}
                    >
                      <img src={shareicon} alt="" />
                      <Link style={{ textDecoration: "none" }}>
                        <span> SHARE THIS</span>
                      </Link>
                      {/* SHARE THIS */}
                    </button>
                    <div className="print">
                      <button
                        className={`primary-btn sm ${activeButtonIndex === 3 ? "active" : ""
                          }`}
                        onClick={() => {
                          setActiveButtonIndex(3);
                          handlePrint();
                        }}
                      >
                        <img src={Printicon} alt="" />
                        <span>Print</span>
                      </button>
                    </div>
                  </div>
                  {/* <div className="car-listing-left d-block d-md-none">
                    <h5>
                      £
                      {Number(cars && cars.price).toLocaleString(
                        "en-IN"
                      )}
                    </h5>
                    <div className="details-box">
                      <div className="inner-title-text">
                        <h3>BODY</h3>
                        <p>
                          {cars &&
                            cars.model &&
                            cars.model.toUpperCase()}
                        </p>
                      </div>
                      <div className="inner-title-text">
                        <h3>MILEAGE</h3>
                        <p>
                          {" "}
                          {Number(
                            cars && cars.mileage
                          ).toLocaleString("en-IN")}{" "}
                          MILES
                        </p>
                      </div>
                      <div className="inner-title-text">
                        <h3>FUEL TYPE</h3>
                        <p>
                          {cars &&
                            cars.model &&
                            cars.fuelType.toUpperCase()}
                        </p>
                      </div>
                      <div className="inner-title-text">
                        <h3>ENGINE</h3>
                        <p>{cars && cars.engine}</p>
                      </div>
                      <div className="inner-title-text">
                        <h3>TRANSMISSION</h3>
                        <p>
                          {cars &&
                            cars.transmission.toUpperCase() ===
                            "AUTOMATIC"
                            ? "AUTO"
                            : cars.transmission.toUpperCase() ===
                              "SEMI AUTOMATIC"
                              ? "SEMI AUTO"
                              : cars.transmission}
                        </p>
                      </div>
                      <div className="inner-title-text">
                        <h3>EXTERIOR COLOUR</h3>
                        <p>
                          {cars &&
                            cars.model &&
                            cars.exteriorColor.toUpperCase()}
                        </p>
                      </div>
                      <div className="inner-title-text">
                        <h3>INTERIOR COLOUR</h3>
                        <p>
                          {cars &&
                            cars.model &&
                            cars.interiorColor.toUpperCase()}
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="stm-accordion-single-unit">
            <div className="container">
              <div className="stm-accordion-title">
                <h3>FREQUENTLY ASKED QUESTIONS</h3>
              </div>
              {faqList.length > 0 &&
                faqList.map((item, index) => (
                  <Accordion key={index}>
                    <Accordion.Item eventKey={index.toString()}>
                      <Accordion.Header>{item.que}</Accordion.Header>
                      <Accordion.Body>{item.ans}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
            </div>
          </div>
        </div>
      )}
      {/* <Modal
        show={modal}
        onHide={() => {
          handleModalClose();
        }}
        className="schedule-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="schedule-container">
            <img src={driveicon} alt="" />
            <h1></h1>
            <p>{cars && cars.details}</p>
            <div className="schedule-form">
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={credentials.name}
                    placeholder="NAME"
                    className="form-control"
                    onChange={handleChange}
                  />
                  {error && error.name.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.name.message}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <input
                    id="email"
                    name="email"
                    value={credentials.email}
                    type="text"
                    placeholder="EMAIL"
                    className="form-control"
                    onChange={handleChange}
                  />
                  {error && error.email.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.email.message}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={credentials.phone}
                    placeholder="PHONE"
                    className="form-control"
                    onChange={handleChange}
                  />
                  {error && error.phone.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.phone.message}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <input
                    id="bestTime"
                    name="bestTime"
                    value={credentials.bestTime}
                    type="text"
                    placeholder="BEST TIME"
                    className="form-control"
                    onChange={handleChange}
                  />
                  {error && error.bestTime.message !== "" && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error.bestTime.message}
                    </div>
                  )}
                </div>
                <button
                  className="primary-btn sm"
                  title="REQUEST"
                  onClick={handleSubmit}
                >
                  REQUEST
                </button>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}

      <Modal
        show={modal2}
        onHide={() => {
          handleModal2Close();
        }}
        className="schedule-modal schedule-modal2"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="schedule-container">
            <div className="schedule-icon">
              <img src={driveicon} alt="" />
            </div>
            <h1>
              {modalType === "vehicle" ? "VEHICLE ENQUIRY" : "PART EXCHANGE"}
            </h1>

            {modalType === "vehicle" ? (
              <div className="schedule-text">
                <div className="schedule-text">
                  <p>{cars && cars.details}</p>
                </div>
              </div>
            ) : null}
            <div className="schedule-form">
              <form>
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="NAME"
                    className="form-control"
                    value={credentials2.name}
                    onChange={handleChange2}
                  />
                  {error2?.name?.message && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error2.name.message}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <input
                    id="email"
                    name="email"
                    type="text"
                    placeholder="EMAIL"
                    className="form-control"
                    value={credentials2.email}
                    onChange={handleChange2}
                  />
                  {error2?.email?.message && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error2.email.message}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="PHONE"
                    className="form-control"
                    value={credentials2.phone}
                    onChange={handleChange2}
                  />
                  {error2?.phone?.message && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error2.phone.message}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <textarea
                    id="message"
                    name="message"
                    placeholder={
                      modalType === "vehicle"
                        ? "Write your enquiry..."
                        : "Enter your car details (Make, Model, Mileage, Year, Registration, LHD/RHD etc...)"
                    }
                    className="form-control"
                    rows={4}
                    value={credentials2.message}
                    onChange={handleChange2}
                  />
                  {error2?.message?.message && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error2.message.message}
                    </div>
                  )}
                </div>

                {/* <div className="form-group">
                  <input
                    id="message"
                    name="message"
                    type="text"
                    placeholder="MESSAGE"
                    className="form-control"
                    value={credentials2.message}
                    onChange={handleChange2}
                  />
                  {error2?.message?.message && (
                    <div className="error-message" style={{ color: "red" }}>
                      {error2.message.message}
                    </div>
                  )}
                </div> */}
                <button
                  className="primary-btn sm"
                  title="SEND"
                  type="submit"
                  onClick={handleSubmit2}
                >
                  SEND
                </button>
              </form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default CarDetails;
